var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c("h1", { staticClass: "titulo" }, [
        _vm._v("Gestão Fila Analise Automatizada")
      ]),
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              configuracaoFiltro: _vm.configuracaoFiltro,
              showPesquisaAvancada: false,
              placeholder: "Pesquise pelo número do processo"
            },
            on: {
              pesquisar: _vm.pesquisar,
              limpar: _vm.clear,
              search: _vm.pesquisar
            }
          })
        ],
        1
      ),
      _vm.showModal
        ? _c("app-modal-fila-manutencao", {
            attrs: {
              conteudoModal: _vm.conteudoModal,
              filtroRapido: _vm.filtroRapido
            },
            on: { closeModal: _vm.closeModal }
          })
        : _vm._e(),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _c("app-listagem", {
        staticClass: "tabela",
        attrs: {
          "has-refresh-button": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.itens,
          pagina: _vm.filtro.pagina,
          hasFiltroRapido: false,
          filtro: _vm.filtro,
          totalElements: _vm.totalElements
        },
        on: {
          updateListagem: _vm.buscarDadosTabela,
          changePage: _vm.changePage,
          executar: _vm.executar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75146f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75146f0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/GestaoFilaAnaliseAutomatizada.vue
// module id = null
// module chunks = 